import {FC} from 'react'
import {Action} from '../types'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {actionDefaultIcon, actionDefaultLabel} from '../utils'
import {useIntl} from 'react-intl'

const ListItem: FC<{action: Action; row: any}> = ({action, row}) => {
  const intl = useIntl()
  const defaultLabel = actionDefaultLabel(action.type)
  const defaultIcon = actionDefaultIcon(action.type)

  const label = action.label ?? defaultLabel
  const icon = action.icon ?? defaultIcon

  const labelHasTranslation = label ? !!intl.messages[label] : false
  const labelTranslation = label && labelHasTranslation ? intl.$t({id: label}) : label

  const renderedLabel = (
    <>
      {typeof icon === 'string' && <i className={clsx('me-1', icon)} />}
      {labelTranslation}
    </>
  )
  if (action.to) {
    return (
      <Link
        to={typeof action.to === 'function' ? action.to(row) : action.to}
        className='dropdown-item d-flex align-items-center justify-content-around'
      >
        {renderedLabel}
      </Link>
    )
  }

  if (typeof action.onClick === 'function') {
    return (
      <span
        className='dropdown-item cursor-pointer d-flex align-items-center justify-content-around'
        onClick={() => action.onClick?.(row)}
      >
        {renderedLabel}
      </span>
    )
  }

  return null
}

const ActionDropdown: FC<{actions: Action[]; row: any}> = ({actions, row}) => (
  <div className='dropdown'>
    <button
      className='btn btn-icon btn-sm btn-light'
      type='button'
      data-bs-toggle='dropdown'
      aria-expanded='false'
    >
      <i className='fas fa-ellipsis-vertical' />
    </button>
    <ul className='dropdown-menu'>
      {actions.map((action: Action, index: number) => (
        <li key={index}>
          <ListItem action={action} row={row} />
        </li>
      ))}
    </ul>
  </div>
)

export default ActionDropdown
